import { t } from 'i18n/index';
import { validateStringField } from 'utils/validations/validateStringField';

// All five fields are required for shipping — unlike the invoice validator,
// which skips address/city and only needs a post code for US/CA.
export const handleValidation = (addressData) => {
  const { name, address, city, post_code, country } = addressData;

  validateStringField(name, 'name', t('errors:nameMissing'));
  validateStringField(address, 'address', t('errors:addressMissing'));
  validateStringField(city, 'city', t('errors:cityMissing'));
  validateStringField(post_code, 'post code', t('errors:postalCodeMissing'));
  validateStringField(country, 'country', t('errors:countryMissing'));
};
